import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5094e353"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar bg-white position-sticky my-0 mx-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "h4" }, "Übergreifende Ziele:", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "cross_objective" }, "Neues übergreifendes Ziel:", -1))
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "cross_rating" }, "Gewichtung:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary w-100 mb-3"
}, " Übergreifendes Ziel hinzufügen ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"3rem"} }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "",
  style: {"color":"#2d3144","position":"absolute","bottom":"0"}
}, [
  /*#__PURE__*/_createTextVNode(" Made with "),
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-heart heart" }),
  /*#__PURE__*/_createTextVNode(" by "),
  /*#__PURE__*/_createElementVNode("img", {
    src: "static/Wortmarke_Schwarz@2x.png",
    alt: "Logo",
    width: "120"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.crossObjectives.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.crossObjectives, (objective, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "mb-2",
              key: index
            }, [
              _createTextVNode(_toDisplayString(objective.title) + " - Wichtigkeit: " + _toDisplayString(objective.weight) + " - Angelegt am: " + _toDisplayString(objective.created_at) + " ", 1),
              _createElementVNode("button", {
                onClick: ($event: any) => (_ctx.deleteCrossObjective(objective.id)),
                class: "btn-danger ker-btn-del btn-sm"
              }, [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'trash-can'] })
              ], 8, _hoisted_4)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_5, "Es wurden keine übergreifenden Ziele eingegeben.")),
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addNewCrossObjective && _ctx.addNewCrossObjective(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          id: "cross_objective",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newObjective) = $event))
        }, null, 512), [
          [_vModelText, _ctx.newObjective]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createElementVNode("input", {
          type: "number",
          class: "form-control",
          id: "cross_weight",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newWeight) = $event)),
          min: "1",
          max: "10"
        }, null, 512), [
          [_vModelText, _ctx.newWeight]
        ])
      ]),
      _hoisted_10
    ], 32),
    _hoisted_11,
    _hoisted_12
  ]))
}